// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3ofGb","feedbackSent":"feedbackSent--3ECyB","feedbackErrors":"feedbackErrors--2KdCE"};